<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar dense color="grey lighten-5" flat>
            <v-icon>mdi-format-align-justify</v-icon>
            <v-toolbar-title class="toolbar-title-2">{{ labels.instalmentList }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-data-table :headers="headers" :items="itemList" class="elevation-1" :loading="loading">
                    <template v-slot:item="row">
                      <tr>
                        <td>{{ row.item.instalNo }}</td>
                        <td>{{ row.item.dueDateFormat }}</td>
                        <td>{{ row.item.premDue }}</td>
                        <td>{{ row.item.disc }}</td>
                        <td>{{ row.item.comm1 }}</td>
                        <td>{{ row.item.comm2 }}</td>
                        <td>{{ row.item.comm3 }}</td>
                        <td>{{ row.item.riskStamp }}</td>
                        <td>{{ row.item.riskFee }}</td>
                        <td>{{ row.item.riskTax }}</td>
                        <td>{{ row.item.polStamp }}</td>
                        <td>{{ row.item.polFee }}</td>
                        <td>{{ row.item.polTax }}</td>
                        <td style="text-align: center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="primary" flat @click.prevent="doSelectItem(row.item)">
                                <v-icon>mdi-magnify</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.query }}</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card v-show="showExpandInstalment">
          <v-toolbar dense color="grey lighten-5" flat>
            <v-icon>mdi-format-align-justify</v-icon>
            <v-toolbar-title class="toolbar-title-3">{{ labels.instalmentDetails }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.tranDate }}</v-subheader>
                  <div class="queryValue">{{ mainForm.tranDate }}</div>
                </v-flex>
                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.instalNo }}</v-subheader>
                  <div class="queryValue">{{ mainForm.instalNo }}</div>
                </v-flex>
                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.totNoInstal }}</v-subheader>
                  <div class="queryValue">{{ mainForm.totNoInstal }}</div>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.dueDate }}</v-subheader>
                  <div class="queryValue">{{ formatDate(mainForm.dueDate) }}</div>
                </v-flex>
                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.premDue }}</v-subheader>
                  <div class="queryValue">{{ mainForm.premDue }}</div>
                </v-flex>
                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.disc }}</v-subheader>
                  <div class="queryValue">{{ mainForm.disc }}</div>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.riskStamp }}</v-subheader>
                  <div class="queryValue">{{ mainForm.riskStamp }}</div>
                </v-flex>
                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.riskFee }}</v-subheader>
                  <div class="queryValue">{{ mainForm.riskFee }}</div>
                </v-flex>
                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.riskTax }}</v-subheader>
                  <div class="queryValue">{{ mainForm.riskTax }}</div>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.polStamp }}</v-subheader>
                  <div class="queryValue">{{ mainForm.polStamp }}</div>
                </v-flex>
                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.polFee }}</v-subheader>
                  <div class="queryValue">{{ mainForm.polFee }}</div>
                </v-flex>
                <v-flex xs12 sm4 md4 lg4>
                  <v-subheader class="queryLabel">{{ labels.polTax }}</v-subheader>
                  <div class="queryValue">{{ mainForm.polTax }}</div>
                </v-flex>

                <v-flex xs12 class="grey lighten-5">
                  <v-toolbar-title class="toolbar-title-3">{{ labels.acctNo1 }} {{ mainForm.acctNo1 }} - {{ mainForm.dAcct1Name }}</v-toolbar-title>
                </v-flex>

                <v-flex xs12 sm3 md3 lg3>
                  <v-subheader class="queryLabel">{{ labels.dInstalPremDue }}</v-subheader>
                  <div class="queryValue">{{ mainForm.dInstalPremDue }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1>
                  <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstStatRateAeprem" disabled></v-checkbox>
                </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstStatPrem }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstStatPremDesc }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1> </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstRatePrem }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstRatePrem }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1>
                  <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstAeprem" disabled></v-checkbox>
                </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstPrem }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstPrem }}</div>
                </v-flex>

                <v-flex xs12 sm3 md3 lg3>
                  <v-subheader class="queryLabel">{{ labels.comm1 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.comm1 }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1>
                  <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstStatRateAecomm1" disabled></v-checkbox>
                </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstStatComm1 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstStatComm1Desc }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1> </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstRateComm1 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstRateComm1 }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1>
                  <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstAecomm1" disabled></v-checkbox>
                </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstComm1 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstComm1 }}</div>
                </v-flex>

                <v-flex xs12 class="grey lighten-5">
                  <v-toolbar-title class="toolbar-title-3">{{ labels.acctNo2 }} {{ mainForm.acctNo2 }} - {{ mainForm.dAcct2Name }}</v-toolbar-title>
                </v-flex>

                <v-flex xs12 sm3 md3 lg3>
                  <v-subheader class="queryLabel">{{ labels.comm2 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.comm2 }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1>
                  <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstStatRateAecomm2" disabled></v-checkbox>
                </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstStatComm2 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstStatComm2Desc }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1> </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstRateComm2 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstRateComm2 }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1>
                  <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstAecomm2" disabled></v-checkbox>
                </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstComm2 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstComm2 }}</div>
                </v-flex>

                <v-flex xs12 class="grey lighten-5">
                  <v-toolbar-title class="toolbar-title-3">{{ labels.acctNo3 }} {{ mainForm.acctNo3 }} - {{ mainForm.dAcct3Name }}</v-toolbar-title>
                </v-flex>

                <v-flex xs12 sm3 md3 lg3>
                  <v-subheader class="queryLabel">{{ labels.comm3 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.comm3 }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1>
                  <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstStatRateAecomm3" disabled></v-checkbox>
                </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstStatComm3 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstStatComm3Desc }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1> </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstRateComm3 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstRateComm3 }}</div>
                </v-flex>
                <v-flex xs2 sm1 md1 lg1>
                  <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstAecomm3" disabled></v-checkbox>
                </v-flex>
                <v-flex xs10 sm2 md2 lg2>
                  <v-subheader class="queryLabel">{{ labels.gstComm3 }}</v-subheader>
                  <div class="queryValue">{{ mainForm.gstComm3 }}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'

export default {
  data() {
    return {
      labels: {
        instalmentList: 'Instalment List',
        query: 'Query',
        instalmentDetails: 'Instalment Details',
        tranDate: 'Transaction Date',
        instalNo: 'Instalment No.',
        totNoInstal: 'Total Instalments',
        dueDate: 'Due Date',
        premDue: 'Premium',
        disc: 'Discount',
        riskStamp: 'Risk Stamp',
        riskFee: 'Risk Fee',
        riskTax: 'Risk Tax',
        polStamp: 'Policy Stamp',
        polFee: 'Policy Fee',
        polTax: 'Policy Tax',
        acctNo1: 'Account 1: ',
        tranTypeDocNo: 'Tran.Type/ Document No.',
        dInstalPremDue: 'Premium Due',
        gstStatPrem: 'GST Status',
        gstRatePrem: 'GST Rate',
        gstPrem: 'GST Premium',
        comm1: 'Commission 1',
        gstStatComm1: 'GST Status',
        gstRateComm1: 'GST Rate',
        gstComm1: 'GST Commission',
        acctNo2: 'Account 2: ',
        comm2: 'Commission 2',
        gstStatComm2: 'GST Status',
        gstRateComm2: 'GST Rate',
        gstComm2: 'GST Commission',
        acctNo3: 'Account 3: ',
        comm3: 'Commission 3',
        gstStatComm3: 'GST Status',
        gstRateComm3: 'GST Rate',
        gstComm3: 'GST Commission'
      },
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        tranDate: undefined,
        instalNo: undefined,
        totNoInstal: undefined,
        dueDate: undefined,
        premDue: undefined,
        disc: undefined,
        riskStamp: undefined,
        riskFee: undefined,
        riskTax: undefined,
        polStamp: undefined,
        polFee: undefined,
        polTax: undefined,
        acctNo1: undefined,
        tranTypeDocNo: undefined,
        dInstalPremDue: undefined,
        gstStatRateAeprem: undefined,
        gstStatPrem: undefined,
        gstRatePrem: undefined,
        gstPrem: undefined,
        comm1: undefined,
        gstStatComm1: undefined,
        gstRateComm1: undefined,
        gstComm1: undefined,
        acctNo2: undefined,
        comm2: undefined,
        gstStatComm2: undefined,
        gstRateComm2: undefined,
        gstComm2: undefined,
        acctNo3: undefined,
        comm3: undefined,
        gstStatComm3: undefined,
        gstRateComm3: undefined,
        gstComm3: undefined,
        dAcct1Name: undefined,
        dAcct2Name: undefined,
        dAcct3Name: undefined,
        acct1tranType1: undefined,
        acct1docNo: undefined,
        acct2tranType1: undefined,
        acct2docNo: undefined,
        acct3tranType1: undefined,
        acct3docNo: undefined,
        gstStatRateAecomm1: undefined,
        gstStatRateAecomm2: undefined,
        gstStatRateAecomm3: undefined,
        gstAeprem: undefined,
        gstAecomm1: undefined,
        gstAecomm2: undefined,
        gstAecomm3: undefined,
        gstStatPremDesc: undefined,
        gstStatComm1Desc: undefined,
        gstStatComm2Desc: undefined,
        gstStatComm3Desc: undefined
      },
      headers: [
        { text: 'No.', value: 'instalNo' },
        { text: 'Due Date', value: 'dueDateFormat' },
        { text: 'Prem', value: 'premDue' },
        { text: 'Disc', value: 'disc' },
        { text: 'Comm1', value: 'comm1' },
        { text: 'Comm2', value: 'comm2' },
        { text: 'Comm3', value: 'comm3' },
        { text: 'R.Stamp', value: 'riskStamp' },
        { text: 'R.Fee', value: 'riskFee' },
        { text: 'R.Tax', value: 'riskTax' },
        { text: 'P.Stamp', value: 'polStamp' },
        { text: 'P.Fee', value: 'polFee' },
        { text: 'P.Tax', value: 'polTax' },
        { text: 'Actions', value: 'action', align: 'center' }
      ],
      itemList: [],
      loading: false,
      showExpandInstalment: true,
      gstStatList: []
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    getFirstInstalment() {
      return this.itemList.filter((item) => {
        return item.instalNo === this.itemList[0].instalNo
      })
    }
  },
  methods: {
    async doInit() {
      if (this.$store.state.underwriting.policySummarySettings.init !== 1) {
        this.$store.dispatch('policySummaryInit').then(() => {
          this.doInit()
          this.getGstStatList()
        })
      } else {
        this.getGstStatList()
      }
      this.getInstalmentList()
    },
    async getGstStatList() {
      const apiUrl = this.$store.state.underwriting.policySummarySettings.menu.gstStatList
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.$set(this, 'gstStatList', data)
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url.[gstStatList]')
      }
    },
    async getInstalmentList() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.premInstalBillList
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          this.displayInstalmentList(result).then(() => {
            this.loading = false
            if (this.getFirstInstalment.length > 0) {
              this.doSetInstalment(this.getFirstInstalment[0])
            }
          })
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url.[premInstalBillList]')
      }
    },
    async displayInstalmentList(result) {
      const { data } = result
      if (data) {
        this.itemList = []
        data.data.map((item) => {
          const convertItem = {
            instalNo: item.instalNo,
            dueDateFormat: formatDisplayDate(item.dueDate),
            dueDate: item.dueDate,
            premDue: formatPrice(item.premDue),
            comm1: formatPrice(item.comm1),
            disc: formatPrice(item.disc),
            polStamp: formatPrice(item.polStamp),
            polFee: formatPrice(item.polFee),
            polTax: formatPrice(item.polTax),
            riskStamp: formatPrice(item.riskStamp),
            riskFee: formatPrice(item.riskFee),
            riskTax: formatPrice(item.riskTax),
            instalDesc: item.instalDesc,
            acct1tranType1: item.acct1tranType1,
            acct1docNo: item.acct1docNo,
            comm2: formatPrice(item.comm2),
            comm3: formatPrice(item.comm3),
            acct2tranType1: item.acct2tranType1,
            acct3tranType1: item.acct3tranType1,
            acct2docNo: item.acct2docNo,
            acct3docNo: item.acct3docNo,
            gstStatPrem: item.gstStatPrem,
            gstStatComm1: item.gstStatComm1,
            gstStatComm2: item.gstStatComm2,
            gstStatComm3: item.gstStatComm3,
            gstRatePrem: formatPrice(item.gstRatePrem),
            gstRateComm1: formatPrice(item.gstRateComm1),
            gstRateComm2: formatPrice(item.gstRateComm2),
            gstRateComm3: formatPrice(item.gstRateComm3),
            gstAeprem: item.gstAeprem,
            gstAecomm1: item.gstAecomm1,
            gstAecomm2: item.gstAecomm2,
            gstAecomm3: item.gstAecomm3,
            gstPrem: formatPrice(item.gstPrem),
            gstComm1: formatPrice(item.gstComm1),
            gstComm2: formatPrice(item.gstComm2),
            gstComm3: formatPrice(item.gstComm3),
            gstStatRateAeprem: item.gstStatRateAeprem,
            gstStatRateAecomm1: item.gstStatRateAecomm1,
            gstStatRateAecomm2: item.gstStatRateAecomm2,
            gstStatRateAecomm3: item.gstStatRateAecomm3,
            dAcct1Name: item.dAcct1Name,
            dAcct2Name: item.dAcct2Name,
            dAcct3Name: item.dAcct3Name
          }
          this.itemList.push(convertItem)
        })
      } else {
        this.itemList = []
      }
    },
    doSetInstalment(data) {
      this.mainForm.tranDate = formatDisplayDate(this.polMaster.tranDate)
      this.mainForm.instalNo = data.instalNo
      this.mainForm.totNoInstal = this.polMaster.totNoInstal
      this.mainForm.dueDate = data.dueDate
      this.mainForm.premDue = data.premDue
      this.mainForm.disc = data.disc
      this.mainForm.riskStamp = data.riskStamp
      this.mainForm.riskFee = data.riskFee
      this.mainForm.riskTax = data.riskTax
      this.mainForm.polStamp = data.polStamp
      this.mainForm.polFee = data.polFee
      this.mainForm.polTax = data.polTax
      this.mainForm.acctNo1 = this.polMaster.acctNo1
      this.mainForm.tranTypeDocNo = data.tranTypeDocNo
      this.mainForm.dInstalPremDue = data.dInstalPremDue
      this.mainForm.gstStatRateAeprem = data.gstStatRateAeprem
      this.mainForm.gstStatPrem = data.gstStatPrem
      this.mainForm.gstRatePrem = data.gstRatePrem
      this.mainForm.gstPrem = data.gstPrem
      this.mainForm.comm1 = data.comm1
      this.mainForm.gstStatComm1 = data.gstStatComm1
      this.mainForm.gstRateComm1 = data.gstRateComm1
      this.mainForm.gstComm1 = data.gstComm1
      this.mainForm.acctNo2 = this.polMaster.acctNo2
      this.mainForm.comm2 = data.comm2
      this.mainForm.gstStatComm2 = data.gstStatComm2
      this.mainForm.gstRateComm2 = data.gstRateComm2
      this.mainForm.gstComm2 = data.gstComm2
      this.mainForm.acctNo3 = this.polMaster.acctNo3
      this.mainForm.comm3 = data.comm3
      this.mainForm.gstStatComm3 = data.gstStatComm3
      this.mainForm.gstRateComm3 = data.gstRateComm3
      this.mainForm.gstComm3 = data.gstComm3
      this.mainForm.dAcct1Name = data.dAcct1Name
      this.mainForm.dAcct2Name = data.dAcct2Name
      this.mainForm.dAcct3Name = data.dAcct3Name
      this.mainForm.acct1tranType1 = data.acct1tranType1
      this.mainForm.acct1docNo = data.acct1docNo
      this.mainForm.acct2tranType1 = data.acct2tranType1
      this.mainForm.acct2docNo = data.acct2docNo
      this.mainForm.acct3tranType1 = data.acct3tranType1
      this.mainForm.acct3docNo = data.acct3docNo
      this.mainForm.gstStatRateAecomm1 = data.gstStatRateAecomm1
      this.mainForm.gstStatRateAecomm2 = data.gstStatRateAecomm2
      this.mainForm.gstStatRateAecomm3 = data.gstStatRateAecomm3
      this.mainForm.gstAeprem = data.gstAeprem
      this.mainForm.gstAecomm1 = data.gstAecomm1
      this.mainForm.gstAecomm2 = data.gstAecomm2
      this.mainForm.gstAecomm3 = data.gstAecomm3
      if (this.getGstStatDesc(this.mainForm.gstStatPrem).length > 0) {
        this.mainForm.gstStatPremDesc = this.getGstStatDesc(this.mainForm.gstStatPrem)[0].label
      } else {
        this.mainForm.gstStatPremDesc = ''
      }
      if (this.getGstStatDesc(this.mainForm.gstStatComm1).length > 0) {
        this.mainForm.gstStatComm1Desc = this.getGstStatDesc(this.mainForm.gstStatComm1)[0].label
      } else {
        this.mainForm.gstStatComm1Desc = ''
      }
      if (this.getGstStatDesc(this.mainForm.gstStatComm2).length > 0) {
        this.mainForm.gstStatComm2Desc = this.getGstStatDesc(this.mainForm.gstStatComm2)[0].label
      } else {
        this.mainForm.gstStatComm2Desc = ''
      }
      if (this.getGstStatDesc(this.mainForm.gstStatComm3).length > 0) {
        this.mainForm.gstStatComm3Desc = this.getGstStatDesc(this.mainForm.gstStatComm3)[0].label
      } else {
        this.mainForm.gstStatComm3Desc = ''
      }
      this.calcPremDue()
    },
    calcPremDue() {
      const dInstalPremDue = parseFloat(removeFormatNumber(this.mainForm.premDue)) + parseFloat(removeFormatNumber(this.mainForm.disc))
      this.mainForm.dInstalPremDue = formatPrice(dInstalPremDue)

      if (this.mainForm.gstAeprem) {
        const gstPrem = (dInstalPremDue * parseFloat(removeFormatNumber(this.mainForm.gstRatePrem))) / 100
        this.mainForm.gstPrem = formatPrice(gstPrem)
      }

      if (this.mainForm.gstAecomm1) {
        if (this.mainForm.comm1 === '') {
          this.mainForm.comm1 = 0
        }
        const gstComm1 = (parseFloat(removeFormatNumber(this.mainForm.comm1)) * parseFloat(removeFormatNumber(this.mainForm.gstRateComm1))) / 100
        this.mainForm.gstComm1 = formatPrice(gstComm1)
      }

      if (this.mainForm.gstAecomm2) {
        if (this.mainForm.comm2 === '') {
          this.mainForm.comm2 = 0
        }
        const gstComm2 = (parseFloat(removeFormatNumber(this.mainForm.comm2)) * parseFloat(removeFormatNumber(this.mainForm.gstRateComm2))) / 100
        this.mainForm.gstComm2 = formatPrice(gstComm2)
      }

      if (this.mainForm.gstAecomm3) {
        if (this.mainForm.comm3 === '') {
          this.mainForm.comm3 = 0
        }
        const gstComm3 = (parseFloat(removeFormatNumber(this.mainForm.comm3)) * parseFloat(removeFormatNumber(this.mainForm.gstRateComm3))) / 100
        this.mainForm.gstComm3 = formatPrice(gstComm3)
      }
    },
    doSelectItem(data) {
      this.showExpandInstalment = true
      this.doSetInstalment(data)
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    getGstStatDesc(gstStat) {
      return this.gstStatList.filter((gst) => {
        return gst.value === gstStat
      })
    }
  },
  mounted() {
    if (this.$store.state.underwriting.policyQuerySettings.init !== 1) {
      this.$store.dispatch('policyQueryInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
